export default __webpack_public_path__ + "6d4bcb38b5f9bc23f866fbac2b51b1dd.png";